"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyleMobileItem = exports.itemsContainer = exports.toggleIconMobile = exports.iconContainer = exports.sectionTitleMobile = exports.header = exports.sectionHeaderMobile = exports.sectionLabelDesktop = exports.rootStyleMobile = exports.rootStyleDesktop = void 0;

var _emotion = require("emotion");

var rootStyleDesktop = function rootStyleDesktop(alignItems, theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;min-width:fit-content;margin-bottom:4px;padding-right:40px;font-size:14px;color:", theme.color.dark.copper, ";align-items:", alignItems, ";border-bottom:1px solid ", theme.color.dark.earth, ";margin-bottom:12px;padding-bottom:4px;margin:10px 15px 0 15px;overflow:visible;")
  );
};

exports.rootStyleDesktop = rootStyleDesktop;

var rootStyleMobile = function rootStyleMobile(alignItems, theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;flex-direction:column;font-size:14px;color:", theme.color.dark.copper, ";align-items:", alignItems, ";padding:0 5px 0 15px;border-bottom:1px solid ", theme.color.dark.mars, ";", expanded &&
    /*#__PURE__*/
    (0, _emotion.css)("background-color:", theme.color.dark.saturn, ";"))
  );
};

exports.rootStyleMobile = rootStyleMobile;
var sectionLabelDesktop =
/*#__PURE__*/
(0, _emotion.css)("width:220px;min-width:220px;padding-right:20px;");
exports.sectionLabelDesktop = sectionLabelDesktop;
var sectionHeaderMobile =
/*#__PURE__*/
(0, _emotion.css)("position:relative;padding:19px 0px;display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;width:100%;");
exports.sectionHeaderMobile = sectionHeaderMobile;
var header =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;padding:16px 0;");
exports.header = header;
var sectionTitleMobile =
/*#__PURE__*/
(0, _emotion.css)("flex:1;");
exports.sectionTitleMobile = sectionTitleMobile;
var iconContainer =
/*#__PURE__*/
(0, _emotion.css)("position:absolute;right:5px;");
exports.iconContainer = iconContainer;

var toggleIconMobile = function toggleIconMobile(theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("fill:", theme.color.dark.white, ";width:14px;height:14px;left:50%;top:50%;transition:all 0.2s ease-in-out;opacity:1;", expanded && "\n    transition: all 0.2s ease-in-out;\n    transform: rotate(180deg);\n    opacity: 1;\n  ")
  );
};

exports.toggleIconMobile = toggleIconMobile;
var itemsContainer =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-wrap:wrap;align-items:center;");
exports.itemsContainer = itemsContainer;
var rootStyleMobileItem =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:14px;letter-spacing:0.1px;line-height:1.31;text-align:left;color:inherit;margin:14px 0px;display:none;&.expanded{display:flex;}");
exports.rootStyleMobileItem = rootStyleMobileItem;